import { MenuData } from '../models/menu-data';


function getAddress(allAddresses, addressId) {
  return allAddresses.find(item => item.id === addressId);
}

function addressToString(address) {
  if (!address) {
    return '';
  }
  return address?.address_name || (address.address2 ? `${address.address1}, ${address.address2}` : address.address1);
}

export function parseMenuData(me, settings, allAddresses, currentAddressId, route = null): MenuData {
  const customer = settings.profile || {};
  const address = getAddress(allAddresses, currentAddressId);
  const hasPlan = (address && address.plan);
  const AllAddressExceptCurrentAddress = allAddresses.filter((addr) => addr.id !== currentAddressId);

  return {
    name: me.name,
    firstName: customer.first_name,
    lastName: customer.last_name,
    hasPlan,
    currentAddress: addressToString(address),
    addresses: AllAddressExceptCurrentAddress,
    openState: false,
    route
  };
}
